<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="session.application_session && companyData!=null">
        <company
          :appId="session.startup_application.id"
          @save-company="saveCompany"
          :data="companyData"
          :edit="edit"
          @edit-change="editchange"
        ></company>
      </div>
    </div>
  </div>
</template>

<style>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
</style>

<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapState } from "vuex";
import { FETCH_APPLICATION, CLEAR_SAVE_MESSAGE } from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";

import store from "@/store";
import CompanyVue from "../../components/pages/Company.vue";
import Loader from "@/components/Loader.vue";

import {
  SET_LabelApp,
  SET_LabelMenuActive,
  SET_HashId
} from "@/store/mutations.type";

export default {
  name: "CompanyEdit",
  components: {
    "sp-button": ButtonVue,
    company: CompanyVue,
    Loader
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(CLEAR_SAVE_MESSAGE);
    next();
  },
  data() {
    return {
      requests: null,
      labelData: null,
      loading: true,
      messageCompany: false,
      companyData: null,
      edit: false
    };
  },
  mounted() {
    // Redirect to the home when startup application is null

    let application_ref = this.$route.params.app_id;
    ApiService.get(`/api/requests/check_label/${application_ref}`)
      .then(data => {
        if (data.data.data.application != null) {
          this.$store.commit(SET_LabelMenuActive, 1);
          let label_ref = data.data.data.label_ref;
          if (label_ref) {
            this.$store.commit(SET_LabelApp, label_ref);
          } else {
            this.$store.commit(SET_LabelApp, null);
          }
        } else {
          this.$store.commit(SET_LabelMenuActive, 0);
        }
      })
      .catch(() => {
        this.$router.push({ name: "home" });
      });

    this.$store.commit(SET_HashId, this.$route.params.app_id);
    if (this.session.startup_application == null) {
      this.$store
        .dispatch(FETCH_APPLICATION, this.$route.params.app_id)
        .then(() => {
          this.checkCompany();
        });
    } else {
      this.checkCompany();
    }
  },
  methods: {
    editchange(val) {
      this.edit = val;
    },
    checkCompany() {
      //let hash_id = this.$route.params.app_id;
      ApiService.get(`/companies/${this.hashId}`)
        .then(data => {
          this.labelData = data.data.data;
          this.companyData = Object.assign({}, this.labelData.company);
          this.loading = false;
          if (this.companyData.activity_domain != null) this.edit = true;
          if (this.companyData.sector != null) this.edit = true;
        })
        .catch(() => {
          this.$router.push({ name: "home" });
        });
    },
    saveCompany(msg) {
      this.messageCompany = true;
    }
  },
  computed: {
    ...mapGetters(["session", "hashId"]),
    ...mapState({
      saveMessage: state => state.request.saveMessage
    })
  }
};
</script>

<style>
</style>
